import type { RejectionCategory } from '../../shared/eligibilityTypes'

/** Category-specific guidance messages for the rejection banner. Product-owned UI copy. */
export const REJECTION_GUIDANCE: Record<RejectionCategory, string> = {
  invalid_dob: "Verify the patient's date of birth matches what the payer has on file.",
  member_not_found: 'Verify the member ID and check the payer is correct.',
  coverage_terminated: 'Coverage is no longer active. Contact the payer to confirm.',
  no_match_or_invalid_subscriber: 'Payer could not match this subscriber. Verify all patient details.',
  other: 'Verify the member ID, date of birth, and payer, then try again.',
}

/**
 * Shown when the rejection carries a provider-level AAA code (41/43/44) —
 * the payer is refusing the *provider*, not the patient. Replaces the raw
 * vendor resolution text that previously rendered in this slot (#103).
 */
export const PROVIDER_ENROLLMENT_GUIDANCE =
  "This usually means the payer doesn't recognize the provider for electronic " +
  "eligibility — most often the provider isn't enrolled with this payer yet, or " +
  "the provider's NPI or Tax ID on file doesn't match the payer's records. " +
  'Verify the provider details, or contact VitalRev AI support.'
